import type { ProductDto, ProductKey } from '@/types/dtos/orders/response/product.dto';
import { PRODUCT_KINDS, PRODUCT_SCOPE_TYPES } from '@/types/dtos/orders/response/product.dto';

export function productGrantsCommercialFeatureKey(product: ProductDto, featureKey: string): boolean {
  if (product.scopeType !== PRODUCT_SCOPE_TYPES.EVENT) {
    return false;
  }
  if (product.kind === PRODUCT_KINDS.FEATURE && product.featureConfig?.featureKey === featureKey) {
    return true;
  }
  if (
    product.kind === PRODUCT_KINDS.PACKAGE &&
    product.packageConfig?.includes?.features?.some((f) => f === featureKey)
  ) {
    return true;
  }
  return false;
}

export function productGrantsAnyCommercialFeatureKey(product: ProductDto, featureKeys: string[]): boolean {
  return featureKeys.some((key) => productGrantsCommercialFeatureKey(product, key));
}

export function filterProductKeysByCommercialFeatureKeys(
  productKeys: ProductKey[],
  products: ProductDto[],
  featureKeys: string[] | undefined,
): ProductKey[] {
  if (!featureKeys?.length) {
    return productKeys;
  }
  return productKeys.filter((productKey) => {
    const product = products.find((p) => p.key === productKey);
    return product && productGrantsAnyCommercialFeatureKey(product, featureKeys);
  });
}
